import Vue from 'vue'
import VueRouter from 'vue-router'
import { routerBeforeEach, routerAfterEach } from '@/config/interceptors/router'
import appraising from './appraising-declare' //评优申报
import project from './project-declare' //项目申报
import activity from './activity' //活动报名
import review from './review' //评审打分
import system from './system' //制度索引
import dealt from './dealt-list' //我的待办列表
import message from './message' //我的消息列表
import difficult from './difficult' //困难申请
import cleanCertificate from './clean-certificate' //廉洁证明
import user from './user' //个人信息。党组织信息等
import newsCenterRouter from './news-center'
import newsDetail from './news-detail'
import declarationSigning from './declaration-signing' //职业操守宣言
import publishSentiment from './public-sentiment' //舆情管理
import voiceAdviceList from './voice-advice'
import questionnaire from './questionnaire' // 满意度调查
import solicitOpinions from './solicitOpinions' // 征集意见
import newHomeCenterRouter from './new-home-router'
import outerLink from './outerLink'
const IndexPage = () => import('@/views/index')
// const LoginPage = () => import('@/views/login')
const newsCenter = () => import('@/views/news-center')
const homePage = () => import('@/views/news-core/home-page')
const newHomeCenter = () => import('@/views/new-home')

// 解决导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

export const routes = [
  {
    path: '/',
    name: 'login',
    component: homePage,
    redirect:'homePage'//默认路由跳转
  },
  // {
  //   path: '/homePage',
  //   name: 'homePage',
  //   component: homePage
  // },
  {
    path: '/index',
    name: 'index',
    component: IndexPage
  },
  {
    path: '/newsCenter',
    name: 'newsCenter',
    component: newsCenter,
    children: [
      ...newsCenterRouter,
      ...newsDetail
    ]
  },
  {
    path: '/newHomeCenter',
    name: 'newHomeCenter',
    component: newHomeCenter,
    children: [
      ...newHomeCenterRouter
    ]
  },
  {
    path: '/401',
    name: '401',
    component: () => import('@/views/401')
  },
  ...appraising,
  ...project,
  ...activity,
  ...review,
  ...system,
  ...dealt,
  ...message,
  ...difficult,
  ...user,
  ...declarationSigning,
  ...cleanCertificate,
  ...publishSentiment,
  ...questionnaire,
  ...voiceAdviceList,
  ...publishSentiment,
  ...questionnaire,
  ...solicitOpinions,
  ...outerLink
]

const router = new VueRouter({
  routes
})

router.beforeEach(routerBeforeEach)
router.afterEach(routerAfterEach)

export default router
